import styled from 'styled-components';

const DeviceNotCompatibleModalQrContainer = styled.div<React.CSSProperties>`
  display: flex;
  justify-content: center;
`;

export default DeviceNotCompatibleModalQrContainer;
